// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form_title__HykCw {
  background: var(--mui-palette-primary-200) !important;
  border: unset;
}

.form_iconColor__Rd-FE {
  stroke: var(--mui-palette-primary-900);
  stroke-width: 0;
  fill: var(--mui-palette-primary-900);
}
`, "",{"version":3,"sources":["webpack://./src/components/most/list/scheduled-jobs/form/index.module.css"],"names":[],"mappings":"AAAA;EACE,qDAAqD;EACrD,aAAa;AACf;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,oCAAoC;AACtC","sourcesContent":[".title {\n  background: var(--mui-palette-primary-200) !important;\n  border: unset;\n}\n\n.iconColor {\n  stroke: var(--mui-palette-primary-900);\n  stroke-width: 0;\n  fill: var(--mui-palette-primary-900);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `form_title__HykCw`,
	"iconColor": `form_iconColor__Rd-FE`
};
export default ___CSS_LOADER_EXPORT___;
